var map = {
	"./test.cli.js": 9,
	"./test.dispensary.js": 13,
	"./test.hasher.js": 22,
	"./test.logger.js": 23,
	"./test.main.js": 24,
	"./test.utils.js": 27
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8;


//////////////////
// WEBPACK FOOTER
// ./tests .*?test\..*?.js$
// module id = 8
// module chunks = 0